import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux';
import PropTypes from 'prop-types'
import BackgroundImage from '../../components/BackgroundImage'
import { Row, Col } from 'react-flexbox-grid';
import { formValueSelector, Field, reduxForm } from 'redux-form'
import Textfield from '../signup/components/Textfield'
import * as Validate from '../../helpers/validations'
import signUpStyles from '../signup/styles/signUp.module.scss'
import Button from '../../components/Button'
import loginStyles from '../login/login.module.scss'
import { forgotPassword, clearUserState } from '../../actions/user-actions'

export class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorLabel: '',
            isVisibleMessage: false,
            emailLabel: ''
        }
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.props.clearState();
    }

    componentWillUpdate(prevProps) {
        if (this.props.mailSuccess && !prevProps.mailSuccess && !this.props.loading) {
            this.setState({
                isVisibleMessage: true,
                emailLabel: this.props.email
            })
            this.props.initialize({
                email: null
            });
        }
        if (this.props.mailError && !prevProps.mailError && !this.props.loading) {
            this.setState({
                errorLabel: this.props.errorMessage
            })
        }
    }

    onSubmit = (email) => {
        this.props.forgotPassword(email);
    }

    goToLogin = () => {
        window.location.href = "/";
    }

    render() {
        const { handleSubmit, pristine, submitting, invalid } = this.props;
        return (
            <BackgroundImage form active={this.props.showLoading}>
                <Row>
                    <Col xs={12}>
                        <Row center="xs" className={loginStyles.__form}>
                            <Col xs={10}>
                                <Row center="xs" className={signUpStyles.__wrapper}>
                                    <img src="/images/logo.png" className={signUpStyles.__logo} alt="Liveli Logo" />
                                    <Col xs={12}>
                                        <span className={signUpStyles.__title}>
                                            Reset Your Password
                                        </span>
                                    </Col>
                                    <Col xs={12}>
                                        <p>
                                            Use your email address to reset your password
                                        </p>
                                    </Col>
                                    <Col xs={10}>
                                        <form onSubmit={handleSubmit(this.onSubmit)}>
                                            <Field
                                                name="email"
                                                label="email"
                                                props={{
                                                    input_type: 'text',
                                                    label: 'Email Address',
                                                    loginView: true
                                                }}
                                                component={Textfield}
                                                validate={[Validate.required, Validate.email]}
                                            />
                                            {this.state.isVisibleMessage &&
                                                <div className={loginStyles.__message}>
                                                    <p style={{ color: 'green' }}>Email sent to {this.state.emailLabel}, please check your spam emails.</p>
                                                </div>
                                            }
                                            <Button type='submit' disabled={invalid || submitting || pristine} login label="Send email" />
                                        </form>
                                        <Button type='primary' login label="Cancel" click={this.goToLogin} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </BackgroundImage>
        )
    }
}

const form = reduxForm({
    form: 'forgotPassword'
})

ForgotPassword.propTypes = {
    forgotPassword: PropTypes.func,
    email: PropTypes.string,
}

const mapStateToProps = (state) => {
    const selector = formValueSelector('forgotPassword');
    return {
        email: selector(state, 'email'),
        mailError: state.userReducer.mailError,
        mailSuccess: state.userReducer.mailSuccess,
        mailData: state.userReducer.mailData,
        errorMessage: state.userReducer.errorMessage,
        loading: state.userReducer.loading,
        showLoading: state.loadingReducer.showLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        forgotPassword: (userData) => dispatch(forgotPassword(userData)),
        clearState: () => dispatch(clearUserState())
    }
}

export default compose(
    form,
    connect(
        mapStateToProps,
        mapDispatchToProps)
)(ForgotPassword)